export const MEETING_ACCESS_GRANTED = 200
export const MEETING_INVITE_PENDING = 201
export const MEETING_LOGIN_REQUIRED = 202
